(function () {
    "use strict";

    angular
        .module("app")
        .directive("collectionSearchHelp", ["SearchFactory", collectionSearchHelp]);

    function collectionSearchHelp(searchFactory) {
        return {
            restrict: "E",
            link: function (scope) {

                scope.search = function (forValidation) {

                    if (scope.readOnly === true) {
                        return;
                    }

                    if (forValidation && (!scope.displayValue || scope.displayValue.trim().length === 0)) {
                        scope.collectionKey = "";
                        scope.collectionName = "";
                        scope.prevDisplayValue = "";
                        scope.displayValue = "";
                        return;
                    }

                    scope.needToValidate = forValidation ? true : false;

                    if (forValidation && (scope.prevDisplayValue === scope.displayValue || scope.collectionName === scope.displayValue)) {
                        
                        scope.needToValidate = false;
                        return;
                    }

                    var modalSearch = searchFactory.collectionSearch(function (collection) {
                        scope.collectionKey = collection ? collection.CollectionKey : "";
                        scope.collectionName = collection ? collection.CollectionName : "";
                        scope.displayValue = scope.collectionName;

                        if (scope.prevDisplayValue !== scope.displayValue) {
                            scope.setDirtyCallback();
                        }

                        scope.prevDisplayValue = scope.displayValue;
                        scope.needToValidate = false;
                    });

                    modalSearch.startSearch(forValidation, ["", scope.displayValue]);
                };

                scope.$watch("collectionName", function (newValue) {
                    scope.displayValue = newValue;
                });

                scope.displayValue = scope.collectionName;
                scope.prevDisplayValue = scope.displayValue;
            },
            scope: { collectionKey: "=", collectionName: "=?", readOnly: "=", needToValidate: "=?", setDirtyCallback: "&" },
            templateUrl: templateUrl("app/directives/searchHelp/searchHelp.directive.html")
        };
    }
})();

